<template>
  <div :class="!resumo ? 'pa-4' : ''">
    <core-grid ref="grid" flat modal :onRead="onRead" :schema="schema" :hide-all-options="resumo" :hide-default-footer="resumo">
    </core-grid>
    <PropostaGarantiaEdit ref="editar" :proposta="value" @close="response" :registros="registros" :tipo-pessoa="tipoPessoa"/>
  </div>
</template>

<script>
export default {
  components: {
    PropostaGarantiaEdit: () => import('./PropostaGarantiaEdit'),
  },
  props: {
    resumo: { type: Boolean, default: false },
    value: null,
  },
  data () {
    return {
      datepicker: new Date(),
      registros: [],
      tipoPessoa: null
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    schema () {
      return [
        { text: 'GRUPO', value: 'Grupo', values: this.$api.Estruturadas.GrupoBem },
        { text: 'TIPO DE GARANTIA', value: 'DescricaoSubgrupo' },
        { value: 'VlrTotal', text: 'Valor Total', format: 'decimal' },
        { value: 'VlrRegistro', text: 'Valor do Registro', format: 'decimal', hide: this.value.Situacao !== this.$aux.SituacaoPropostaEnum.EmDigitacao }
      ].filter(p => !p.hide)
    }
  },
  methods: {
    load () {
      this.refresh()
    },
    onRead: function (options) {
      const th = this
      const dto = { parameters: [{ name: 'CodigoProposta', value: th.value.Codigo }] }
      th.$api.Multiplo.Post('ListPropostaGarantiaBem', dto).then(async function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.tipoPessoa = th.$api.UI.Format.SomenteNumeros(th.value.Cliente.DocumentoFederal).length === 11 ? 1 : 2
          if (th.value.Situacao === th.$aux.SituacaoPropostaEnum.EmDigitacao && th.$param.EST_VALORES && th.$param.EST_VALORES.Registro && th.$param.EST_VALORES.Registro.length > 0) {
            th.registros = th.$param.EST_VALORES.Registro
            for (var i = 0; i < response.Data.length; i++) {
              response.Data[i].VlrRegistro = await th.$api.Estruturadas.GetValorRegistroGarantia(th, response.Data[i], th.tipoPessoa, th.registros)
            }
          }
          options.success(response.Data)
        }
      })
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    response (data) {
      if (data) { this.refresh() }
    },
    excluir (current) {
      const th = this
      if (current) {
        const dto = {
          guidID: current.Codigo,
        };
        th.$api.Multiplo.Post('RemoverPropostaGarantiaBem', dto).then(function (
          data
        ) {
          if (th.$api.UI.PostAction(data)) {
            const parameters = [
              { name: 'CodigoProposta', value: th.model.Codigo },
            ];
            th.$api.Multiplo.Post('ListCCBDigitalAssinatura', {
              parameters,
            }).then((response) => {
              if (th.$api.UI.PostLoadData(response)) {
                const assinante = response.Data.find(
                  ({ Documento, Descricao }) =>
                    Documento === th.$api.UI.Format.SomenteNumeros(current.DocumentoFederalProprietario) &&
                    Descricao === 'TERCEIRO GARANTIDOR'
                );

                if (assinante) {
                  th.$api.Multiplo.Post('RemoveCCBDigitalAssinaturas', {
                    dto: [assinante.Codigo],
                  }).then(function (responseRemover) {
                    if (th.$api.UI.PostLoadData(responseRemover, true)) {
                      th.refresh();
                    }
                  });
                } else {
                  th.refresh();
                }
                if (th.model.TipoContratoSigla === 'NCI') {
                  th.updatePropostaCampoAuxiliar(current.Codigo)
                }
              }
            });
          }
        });
      }
    },
    submit (callback) {
      const th = this
      if (th.model.TipoOperacaoCred === 1) {
        const dto = { parameters: [{ name: 'CodigoProposta', value: th.value.Codigo }] }
        th.$api.Multiplo.Post('ListPropostaGarantiaBem', dto).then(function (response) {
          if (th.$api.UI.PostLoadData(response, true)) {
            if (response.Count <= 0) {
              th.$api.UI.ShowError('Operação não permitida', th.$getErrorMessage('garantia').message)
            } else {
              th.$api.Estruturadas.GetValorRegistro(th, th.model).then(() => {
                th.$api.Estruturadas.SaveProposta(th, callback)
              })
            }
          }
        })
      } else {
        callback()
      }
    },
    updatePropostaCampoAuxiliar (codigoGarantia) {
      const th = this
      const dto = {
        parameters: [{ name: 'CodigoProposta', value: th.model.Codigo }]
      }
      th.$api.Multiplo.Post('ListPropostaCampoAuxiliar', dto).then((response) => {
        if (th.$api.UI.PostLoadData(response, true)) {
          if (response.Data && response.Data.length > 0) {
            response.Data.forEach((item) => {
              if (item.NomeCampo === 'VALOR_IMOVEL_FINS_LEILAO') {
                var garantiaVlrImovelLeilao = JSON.parse(item.ValorCampo).filter(p => p.CodigoGarantia !== codigoGarantia)
                const campoAux = [{ CodigoProposta: th.model.Codigo, NomeCampo: 'VALOR_IMOVEL_FINS_LEILAO', ValorCampo: JSON.stringify(garantiaVlrImovelLeilao) }]
                th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campoAux })
              }
            })
          }
        }
      })
    },
  }
}
</script>
